// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  fetchAntennaApplications,
  fetchAntennaClassifications,
  fetchAntennaCompliances,
  fetchAntennaCompanies,
  fetchAntennaStatuses,
  fetchAntennaPatternPolarizations,
  fetchAntennaPolarizations,
} from 'helpers/api'

import sortByCompanyName from './helpers/sortByCompanyName'

import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'
import catchEmptySettings from './catchEmptySettings'

import {
  addAntennaSettings,
} from 'redux/modules/domain'

const fetchAndAddAntennaSettings = () => async dispatch => {
  const settings = [
    fetchAntennaApplications(),
    fetchAntennaClassifications(),
    fetchAntennaCompanies(),
    fetchAntennaCompliances(),
    fetchAntennaStatuses(),
    fetchAntennaPatternPolarizations(),
    fetchAntennaPolarizations(),
  ]

  let r

  try {
    r = await Promise.all(settings)
  } catch (err) {
    console.warn(err)
    dispatch(settingsFailedToLoadMessage('Antenna', err))
    return {}
  }

  const antennaApplications = r[0].entities
  const antennaClassifications = r[1].entities
  const antennaCompanies = sortByCompanyName(r[2].entities)
  const antennaCompliances = r[3].entities
  const antennaStatuses = r[4].entities
  const antennaPatternPolarizations = r[5].entities
  const antennaPolarizations = r[6].entities

  const antennaSettings = {
    antennaApplications,
    antennaClassifications,
    antennaCompanies,
    antennaCompliances,
    antennaStatuses,
    antennaPatternPolarizations,
    antennaPolarizations,
  }

  dispatch(catchEmptySettings('Antenna', antennaSettings))
  dispatch(addAntennaSettings(antennaSettings))
  return antennaSettings
}

export default fetchAndAddAntennaSettings
